import isEmpty from "lodash/isEmpty";
import { RootState } from "../reducers";

export const getAddVehicleByPlateVin = (state: RootState) =>
  state.partnerDetails?.partnerDetails?.experience?.addVehicleByPlateVin;
export const getAmazonConnectSelector = (state: RootState) => state.partnerDetails?.partnerDetails?.amazonConnect;
export const getAppId = (state: RootState) => state.partnerDetails?.partnerDetails?.appId;
export const getBenefitsEnabled = (state: RootState) =>
  !!state.partnerDetails?.partnerDetails?.experience?.benefitsEnabled;
export const getDisplayCode = (state: RootState) => state.partnerDetails?.partnerDetails?.displayCode;
export const getPartnerAppId = (state: RootState) => state.partnerDetails?.partnerDetails?.appId;
export const getPartnerCode = (state: RootState) => state.partnerDetails?.partnerDetails?.partnerCode;
export const getPartnerDetails = (state: RootState) => state.partnerDetails?.partnerDetails;
export const getPartnerPhoneNumber = (state: RootState) => state.partnerDetails?.partnerDetails?.phone;
export const getPartnerBrand = (state: RootState) => state.partnerDetails?.partnerDetails?.brand;
export const getPPUEnabled = (state: RootState) => !!state.partnerDetails?.partnerDetails?.experience?.ppuEnabled;
export const getRoute = (state: RootState) => state.partnerDetails?.partnerDetails?.route;
export const getShowSponsoredLocation = (state: RootState) => state.partnerDetails?.partnerDetails?.experience?.showSponsoredLocation;
export const partnerDetailsLoadedSelector = (state: RootState) =>
  state.partnerDetails?.loading === false &&
  state.partnerDetails?.error === false &&
  !isEmpty(state.partnerDetails?.partnerDetails?.experience);
export const getSchedulingEnabled = (state: RootState) => state.partnerDetails?.partnerDetails?.experience?.schedulingEnabled;
export const getOnlyOemVehiclesSupported = (state: RootState) => state.partnerDetails?.partnerDetails?.onlyOemVehiclesSupported;
